// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1516":"cf894fbd9d90d67f049c","3467":"2424f7bec56c5c2fe948"}[chunkId] + ".css";
};